export default "__VITE_ASSET__BzFqpPEK__"